import React, { useMemo } from 'react';
import { observer } from 'mobx-react';
import { BlogPost } from '@portal/types/nexudus/blog';
import BlogPostCard from './BlogPostCard';
import { useFeaturedBlogsQuery } from '../hooks/useBlogs';
import {
  CardGrid,
  RowLayout,
  RowLoadingSkeleton,
} from '../dashboard/dashboardRow';

const WIDGET_PROPS = {
  title: 'Articles',
  manageHref: '/blog',
  manageLabel: 'See all articles',
} as const;

const BlogPostsList: React.FC<{ blogs: BlogPost[] }> = ({ blogs }) => {
  const blogPostsToShow = useMemo(() => blogs.slice(0, 3), [blogs]);

  if (!blogPostsToShow.length) return null;

  return (
    <RowLayout {...WIDGET_PROPS}>
      <CardGrid>
        {blogPostsToShow.map((blogPost) => (
          <BlogPostCard key={blogPost.Id} blogPost={blogPost} />
        ))}
      </CardGrid>
    </RowLayout>
  );
};

// observer: useAuth reads MobX state, so a change of user re-runs the query.
// Renders nothing on error, or when there are no featured posts.
const FeaturedBlogPostSection: React.FC = observer(() => {
  const { data: featuredBlogs, isLoading } = useFeaturedBlogsQuery();

  if (isLoading) return <RowLoadingSkeleton {...WIDGET_PROPS} />;
  return <BlogPostsList blogs={featuredBlogs ?? []} />;
});

export default FeaturedBlogPostSection;
